<template>
  <div v-show="isReady" class="comp-container__send-message">
    <!--  消息列表-->
    <div
      v-show="!showChat"
      v-if="messageList?.length"
      class="message-list-container"
    >
      <div
        class="message-list"
        ref="msgList"
        :style="{
          maxHeight: messageListMaxHeight + 'px',
        }"
      >
        <div
          class="scroll-box"
          ref="scrollBox"
          :class="{ 'is-collapsed': !isMessageListExpanded }"
        >
          <div
            class="message-item"
            v-for="(item, index) in messageList"
            :key="item.timestamp"
            @click="handleClickMessage(item)"
          >
            <msg-text
              v-if="item.type === 'text'"
              :msg-item="item"
              :data="handleTextMessageShowContext(item.payload.text)"
            />
            <hand-up
              v-if="item.type === 'member_hand_up'"
              :msg-item="item"
              @updateMsgItem="(type) => updateMsgItem(type, index)"
            />
            <system-message v-if="item.type === 'system'" :msg-item="item" />
          </div>
        </div>
      </div>
      <!-- 展开收起 -->
      <div
        class="expand-collapse-button"
        @click="handleToggleMessageList"
        :class="{ blinking: shouldBlinkButton }"
      >
        <span
          class="icon el-icon-arrow-left"
          :class="{ 'is-collapsed': !isMessageListExpanded }"
        ></span>
        <span class="text">{{
          isMessageListExpanded ? "收起弹幕" : "展开弹幕"
        }}</span>
      </div>
    </div>
    <div class="operate-wrap">
      <!-- 输入框 -->
      <div
        v-show="!showChat"
        class="input-box"
        :class="{ 'is-focused': isFocus }"
      >
        <span class="shut-up-tips" v-if="isShutUp">已禁言</span>
        <template v-else>
          <face-plugin @select="selectFace" :isMute="isShutUp"></face-plugin>
          <quill-editor
            ref="quill"
            class="quill-editor"
            v-model="message"
            :disabled="isShutUp"
            :options="editorOption"
            @focus="isFocus = true"
            @blur="isFocus = false"
            @change="onEditorChange($event)"
        /></template>
      </div>
      <!-- 举手 -->
      <button
        v-if="isStudent && !isFocus"
        v-preventReClick
        class="hande-btn"
        @click="handleRaiseHand"
        :disabled="isHandRaised"
      >
        <span class="countdown-time" v-if="isHandRaised">{{
          countdownTime
        }}</span>
        <el-tooltip
          v-else
          popper-class="live-room-tooltip"
          effect="dark"
          content="点击举手发言"
          placement="top"
        >
          <img class="icon" src="../../../assets/images/live/hand.png" alt="" />
        </el-tooltip>
      </button>
    </div>
  </div>
</template>

<script>
import { USER_ROLE_NAME } from "@saas/live-sdk/src/services/utils/constants.js";
import { handUp } from "@saas/service-api/src/live-sdk";
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import { uploadLiveLog } from "@saas/components/src/utils/log";
import { handleTextMessageShowContext } from "@saas/components/src/utils/im/message-format";
import MsgText from "../qick-msg-list/Text.vue";
import HandUp from "../qick-msg-list/HandUp.vue";
import SystemMessage from "../qick-msg-list/SystemMessage.vue";
import { emojiUrl } from "@saas/components/src/utils/im/emoji-map";
import FacePlugin from "@saas/pages/src/chat/plugin-components/face/Face.vue";
import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { EventBus } from "@saas/components/src/utils/event-bus";
import {
  isAssistant,
  isTeacher,
  isWhiteboardAndRecord,
  filterMessageByLessonId,
} from "../utils/index.js";
export default {
  props: {
    isReady: {
      type: Boolean,
      default: false,
    },
    lessonId: {
      type: Number,
      default: 0,
    },
  },
  components: {
    quillEditor,
    FacePlugin,
    MsgText,
    HandUp,
    SystemMessage,
  },
  data() {
    return {
      isElectron: window.isElectron,
      messageShowTime: 6, //单位秒
      message: "",
      sendMessageList: [],
      editorOption: {
        placeholder: "说点什么...",
        theme: "snow",
        modules: {
          keyboard: {
            bindings: {
              enter: {
                key: 13,
                handler: () => {
                  this.handleSendMsg();
                  return false;
                },
              },
              "shift+enter": {
                key: 13,
                shiftKey: true,
                handler: () => {
                  return false;
                },
              }, //禁止换行
            },
          },
          clipboard: {
            matchers: [
              ["img", this.desMatcherImage],
              [
                "video",
                () => {
                  return { ops: [] };
                },
              ],
            ],
          },
        },
      },
      messageList: [],
      limitLength: 200,
      isMessageListExpanded: true,
      shouldBlinkButton: false,
      timer: null,
      isHandRaised: false,
      countdownTime: 10,
      countdownTimer: null,
      handTime: 10,
      isSending: false,
      isFocus: false,
    };
  },
  computed: {
    ...mapState("live", [
      "imService",
      "roomInfo",
      "userStatus",
      "liveService",
      // "allMemberStatus",
      "allMemberStatusMap",
      "showRaiseHand",
      "messageMaxHeight",
      "screenShareStatus",
    ]),
    ...mapState("newChat", ["showChat"]),
    ...mapGetters("live", ["isShutUp"]),
    userInfo() {
      return this.$store.getters.user || {};
    },
    groupID() {
      return `${this.roomInfo.id}`;
    },
    isStudent() {
      return USER_ROLE_NAME[this.userStatus?.user_role] === "student";
    },
    messageListMaxHeight() {
      if (!this.messageMaxHeight || this.messageMaxHeight < 165) {
        return 165;
      } else {
        return this.messageMaxHeight - 35;
      }
    },
    isScreenShare() {
      return ["start", "pause"].includes(this.screenShareStatus);
    },
  },
  watch: {
    imService: {
      handler(val) {
        if (val) {
          this.handleIMListen();
        }
      },
      immediate: true,
    },
    liveService: {
      handler(val) {
        if (val) {
          this.handLiveleListen();
        }
      },
      immediate: true,
    },
  },
  methods: {
    ...mapMutations("newChat", ["SET_CHAT_MODE", "SET_SHOW_CHAT"]),
    handleTextMessageShowContext,
    updateMsgItem(type, index) {
      switch (type) {
        case "downstage":
          this.messageList[index].is_up_stage =
            this.messageList[index].is_up_stage === 1 ? 2 : 1;
          break;
        case "whiteboard":
          this.messageList[index].is_whiteboard =
            this.messageList[index].is_whiteboard === 1 ? 2 : 1;
          break;
        case "videoMute":
          this.messageList[index].is_send_video =
            this.messageList[index].is_send_video === 1 ? 2 : 1;
          break;
        case "audioMute":
          this.messageList[index].is_send_audio =
            this.messageList[index].is_send_audio === 1 ? 2 : 1;
          break;
      }
    },
    // 粘贴图片拦截
    desMatcherImage(node, Delta) {
      let res = Delta;
      if (Delta.ops && Delta.ops.length > 0) {
        Delta.ops.forEach((item) => {
          if (item.insert.image && item.insert.image.startsWith(emojiUrl)) {
            this.$nextTick(() => {
              this.addFaceStyle(item.insert.image);
            });
          } else if (item.insert.image) {
            res = { ops: [] };
          }
        });
      }
      return res;
    },
    handleIMListen() {
      this.imService.on("liveGroupChatMessageReceived", this.handleMsgReceived);
      this.imService.on(
        "recvMGLiveRoomCustomMsg",
        this.handleLiveRoomCustomMsg
      );
    },
    handLiveleListen() {
      // todo：trtc信息可以去除
      // this.liveService.on("recvCustomCmdMsg", this.handleLiveRoomCustomMsg);
    },
    handleLiveRoomCustomMsg(res) {
      console.log("==98handleLiveRoomCustomMsg", res);
      const { data, userId, lessonId } = res;
      switch (data?.type) {
        case "member_hand_up":
          if (!this.isStudent) {
            this.addMsgItem({
              ...data?.data,
              timestamp: Date.now(),
              type: "member_hand_up",
              user_id: data?.data?.user_id || userId,
            });
          }
          break;
        case "xhRemoteEnterRoom":
          if (isWhiteboardAndRecord(data?.data?.userId)) {
            return;
          }
          if (filterMessageByLessonId(userId, lessonId, this.roomInfo)) {
            return;
          }
          this.addMsgItem({
            ...data?.data,
            timestamp: Date.now(),
            systemType: "enterRoom",
            type: "system",
            user_id: data?.data?.userId,
          });
          break;
      }
    },
    async handleMsgReceived(res) {
      console.log("live__handleMsgReceived___", res, this.userStatus);
      res = JSON.parse(JSON.stringify(res));
      if (
        res?.from &&
        !(
          res.cloudCustomData &&
          res.cloudCustomData.isPrivateMsg === 1 &&
          res.cloudCustomData.privateInfo.to.id !== this.userInfo.user_id
        )
      ) {
        // if (res?.from) {
        if (res.type === "image") {
          res.type = "text";
          res.payload = {
            text: "发送了一张图片",
            textColor: "#94BFFF",
          };
        } else if (res.type === "file") {
          res.type = "text";
          res.payload = {
            text: "发送了一个文件",
            textColor: "#94BFFF",
          };
        }
        let nameCard = res.nameCard;
        const { from, nick = "" } = res;
        let userRole = 3;
        if (isTeacher(from, this.roomInfo)) {
          userRole = 1;
        } else if (isAssistant(from, this.roomInfo)) {
          userRole = 2;
        }
        if (from === this.userStatus?.user_id) {
          nameCard = this.userStatus?.nickname; // 腾讯的nameCard 返回的是旧值，需要更新为最新的值
        }
        this.addMsgItem({
          ...res,
          nickname: nameCard || nick,
          userRole,
          timestamp: Number(Date.now()),
        });
        if (!this.isMessageListExpanded) {
          this.shouldBlinkButton = true;
        }
      }
    },
    addMsgItem(data) {
      // const info = this.allMemberStatus.find((item) => {
      //   return item.user_id === data.user_id;
      // });
      const info = this.allMemberStatusMap[data.user_id];
      this.messageList.push({ ...data, ...(info || {}) });
      if (!this.isMessageListExpanded) {
        this.shouldBlinkButton = true;
      } else {
        // 消息列表展开时自动滚动到底部，兼容多种情况
        this.$nextTick(() => {
          const msgList = this.$refs.msgList;
          if (msgList) {
            msgList.scrollTop = msgList.scrollHeight;
          }
        });
      }
    },
    onEditorChange({ quill, html, text }) {
      const currentlength = this.$refs.quill.quill.getLength() - 1;

      if (this.limitLength && currentlength >= this.limitLength) {
        this.$refs.quill.quill.deleteText(this.limitLength, 2000000);
      }
    },
    // 获取编辑器光标位置
    getIndex() {
      return this.$refs.quill.quill.selection.savedRange.index; // 获取光标位置
    },
    selectFace(face) {
      const index = this.getIndex();
      this.$refs.quill.quill.insertEmbed(index, "image", face.url);
      this.$refs.quill.quill.setSelection(index + 1);
      this.addFaceStyle(face.url);
    },
    // 给编辑器里面表情添加样式
    addFaceStyle(imageUrl) {
      const imgElements = this.$refs.quill.$el.querySelectorAll(
        `img[src="${imageUrl}"]`
      );
      imgElements.forEach((img) => {
        img.style.maxWidth = "20px";
        img.style.maxHeight = "20px";
        img.style.display = "inline-block";
      });
    },
    async handleSendMsg() {
      if (this.isSending) {
        return;
      }
      this.isSending = true;

      this.formatSendMessage();
      this.sendMessage();
    },
    sendMessage() {
      this.sendMessageList.forEach(async (item) => {
        // 发送文本
        if (item.content === "\n" || !item.content) {
          this.isSending = false;
          return;
        }
        if (this.isShutUp) {
          this.isSending = false;
          return;
        }
        if (!item.content.trim()) {
          this.$darkMessage.error("不能发送空消息");
          this.isSending = false;
          return;
        }
        const params = {
          to: this.groupID,
          conversationType: 2,
          text: item.content.replace(/\n+$/, ""),
          type: "text",
        };
        this.sendRequest(params);
      });
    },
    sendRequest(params) {
      let msg = this.imService.createTextMessage(params);
      this.imService
        .sendMessage(msg)
        .then((res) => {
          console.log("==99发送消息成功", res);
          this.handleMsgReceived(res);
          this.message = "";
          this.isSending = false;
        })
        .catch((err) => {
          console.log("==99发送消息失败", err);
          this.isSending = false;
        });
    },
    // 格式化编辑器的数据
    formatSendMessage() {
      const messageContents = this.$refs.quill.quill.getContents().ops;
      const condition = (item) =>
        item.insert.image && !item.insert.image.startsWith(emojiUrl);
      const res = this.splitArrayByCondition(messageContents, condition);
      this.sendMessageList = this.concatMessage(res);
    },
    splitArrayByCondition(arr, condition) {
      const result = [];
      let currentSubArray = [];

      arr.forEach((element, index) => {
        if (condition(element)) {
          result.push(currentSubArray);
          // 当前元素满足条件，结束当前子数组并开始新的子数组
          currentSubArray = [element];
          result.push(currentSubArray);
          currentSubArray = [];
        } else {
          // 当前元素不满足条件，继续添加到当前子数组
          currentSubArray.push(element);
        }
        if (index === arr.length - 1) {
          // 处理最后一个元素
          result.push(currentSubArray);
        }
      });

      return result;
    },
    // 拼接消息
    concatMessage(msgList) {
      const res = msgList.map((subList) => {
        let message = {
          content: "",
          type: "",
        };
        subList.forEach((item) => {
          if (item.insert.image && item.insert.image.startsWith(emojiUrl)) {
            const url = item.insert.image;
            const name = `[${url
              .replace(emojiUrl, "")
              .replace(/\.gif|\.png/g, "")}]`;
            message.content += decodeURIComponent(name);
            message.type = "text";
            // 发送图片
          } else if (typeof item.insert === "string") {
            // 发送文本
            message.content += item.insert;
            message.type = "text";
          } else if (
            item.insert.image &&
            !item.insert.image.startsWith(emojiUrl)
          ) {
            message.content += item.insert.image;
            message.type = "image";
          }
        });
        return message;
      });
      return res;
    },
    getMessageList() {
      console.log("==99获取消息列表", this.imService, this.$store.state.live);
      this.imService
        .getMessageList({
          conversationID: "GROUP" + this.groupID,
        })
        .then((res) => {
          // this.messageList = res.messageList || [];
          console.log("==99获取消息列表成功", res);
        })
        .catch((err) => {
          console.log("==99获取消息列表失败", err);
        });
    },
    handleToggleMessageList() {
      this.isMessageListExpanded = !this.isMessageListExpanded;
      this.shouldBlinkButton = false;
      if (this.isMessageListExpanded) {
        // 消息列表展开时自动滚动到底部，兼容多种情况
        this.$nextTick(() => {
          const msgList = this.$refs.msgList;
          if (msgList) {
            msgList.scrollTop = msgList.scrollHeight;
          }
        });
      }
    },
    startMessageTimer() {
      if (this.timer) {
        clearInterval(this.timer);
      }
      this.timer = setInterval(this.removeOldMessages, 1000);
    },
    removeOldMessages() {
      const currentTime = Date.now();
      this.messageList = this.messageList.filter((message) => {
        const messageAgeThreshold = this.messageShowTime * 1000;
        return currentTime - message.timestamp <= messageAgeThreshold;
      });
    },
    handleRaiseHand() {
      if (this.isHandRaised) {
        return;
      }
      this.isHandRaised = true;
      this.countdownTime = this.handTime;

      this.countdownTimer = setInterval(() => {
        this.countdownTime--;
        if (this.countdownTime <= 0) {
          clearInterval(this.countdownTimer);
          this.isHandRaised = false;
          this.countdownTime = this.handTime;
        }
      }, 1000);
      const {
        is_send_audio,
        is_send_video,
        is_up_stage,
        is_whiteboard,
        user_id,
        nickname,
        user_role,
      } = this.userStatus;
      let actionData = {
        is_up_stage,
        is_whiteboard,
        user_id,
        nickname,
        user_role,
        is_send_audio,
        is_send_video,
        time: Math.floor(Date.now() / 1000),
      };
      console.log("==99actionData举手", actionData);
      if (is_up_stage === 1) {
        // 在台上
        actionData = {
          ...actionData,
          is_send_audio: this.userStatus.audio_state,
          is_send_video: this.userStatus.video_state,
        };
      } else {
        // 不在台上
        // const userStatus = this.allMemberStatus.find((item) => {
        //   return item.user_id === user_id;
        // });
        const userStatus = this.allMemberStatusMap[user_id];
        if (userStatus) {
          const { is_send_audio, is_send_video } = userStatus;
          actionData = {
            ...actionData,
            is_send_audio,
            is_send_video,
          };
        }
      }
      handUp({
        room_id: this.roomInfo.id,
      })
        .then(async (res) => {
          if (res.code === 1) {
            const data = {
              cmdId: 2,
              data: {
                type: "member_hand_up",
                data: actionData,
              },
            };
            // 发送im 自定义消息
            this.imService.sendMGLiveRoomCustomMsg(data);
            EventBus.$emit("member_hand_up", { user_id });
          } else {
            this.$darkMessage.error(res.message);
          }
        })
        .catch((err) => {
          this.$darkMessage.error("举手失败");
          console.log("举手失败", err);
        });
    },
    addDocumentClickListener() {
      document.addEventListener("click", this.handleDocumentClick);
    },
    removeDocumentClickListener() {
      document.removeEventListener("click", this.handleDocumentClick);
    },
    handleDocumentClick(event) {
      const inputBox = this.$el.querySelector(".input-box");
      if (inputBox && !inputBox.contains(event.target)) {
        if (this.$refs.quill && this.isFocus) {
          this.$refs.quill.quill.blur();
        }
      }
    },
    handleClickMessage(item) {
      uploadLiveLog({
        message: "用户点击快捷消息",
        extra: {
          action: "click_message",
          messageType: item?.type,
          messageId: item?.timestamp,
        },
      });

      if (window.isElectron && this.isScreenShare) {
        this.SET_SHOW_CHAT(true);

        if (window.LiveElectronApi) {
          window.LiveElectronApi.openChatWindow();
        }
        // window.ipcRenderer.send("chat-create-window", {
        //   url: window.location.origin,
        // });
        this.SET_CHAT_MODE("popup");
      }
    },
  },
  mounted() {
    // 启动消息定时器
    this.startMessageTimer();
    this.addDocumentClickListener();
  },
  beforeDestroy() {
    // 清除定时器
    if (this.timer) {
      clearInterval(this.timer);
    }
    if (this.countdownTimer) {
      clearInterval(this.countdownTimer);
    }
    this.removeDocumentClickListener();
    this.imService.off("liveGroupChatMessageReceived", this.handleMsgReceived);
    this.imService.off("recvMGLiveRoomCustomMsg", this.handleLiveRoomCustomMsg);
  },
};
</script>

<style lang="scss" scoped>
.comp-container__send-message {
  .operate-wrap {
    display: flex;
    align-items: center;
  }
  .hande-btn {
    width: 36px;
    height: 36px;
    background: #27272a;
    box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.05);
    border-radius: 10px 10px 10px 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 8px;
    transition: width 0.3s ease, margin-left 0.3s ease, opacity 0.3s ease;
    &:disabled {
      cursor: not-allowed;
      opacity: 1;
      pointer-events: auto;
    }
    .icon {
      width: 20px;
      height: 20px;
    }
    .countdown-time {
      font-weight: 500;
      font-size: 14px;
      color: #17c964;
      line-height: 1;
    }
  }
  .input-box {
    width: 184px;
    height: 36px;
    background: #27272a;
    box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.05);
    border-radius: 10px 10px 10px 10px;
    display: flex;
    align-items: center;
    padding: 0 12px;
    transition: width 0.3s ease;
    &.is-focused {
      width: calc(
        184px + 36px + 8px
      ); // 初始宽度 + 举手按钮宽度 + 举手按钮margin-left
    }
    .shut-up-tips {
      font-weight: 500;
      font-size: 14px;
      color: #86909c;
      line-height: 1;
    }
    ::v-deep .face-main {
      left: -12px !important;
      z-index: 980;
      background: #18181b;
      box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.05);
      border-radius: 8px;
      border: 1px solid rgba(229, 231, 235, 0.04);
      .face-list {
        &::-webkit-scrollbar-thumb {
          background-color: #27272a;
        }
      }
    }
  }

  .quill-editor {
    margin-left: 6px;
    flex: 1;
    width: 0;
    ::v-deep .ql-container {
      border: none;
      &.ql-snow {
        border: none;
        border-radius: 0;
      }
      .ql-editor {
        font-weight: 500;
        font-size: 14px;
        color: #ffffff;
        line-height: 24px;
        height: 24px;
        padding: 0 !important;
        white-space: nowrap;
        overflow-x: auto;
        overflow-y: hidden;
        // scroll-snap-type: x mandatory;
        // scroll-behavior: smooth;
        scrollbar-width: 0;
        /* 标准语法，Firefox 支持 */
        -ms-overflow-style: none;
        /* IE 和 Edge */
        &::-webkit-scrollbar {
          display: none;
          /* WebKit 内核浏览器 */
        }
        &::before {
          font-style: normal;
          left: 0;
        }
        p,
        span,
        div {
          background-color: unset !important;
          word-break: break-all;
        }
        img {
          max-width: 100%;
          background-color: unset !important;
        }
        &.ql-blank::before {
          color: #86909c;
          font-weight: 500;
          font-size: 14px;
        }
      }
    }
    ::v-deep .ql-toolbar {
      display: none;
    }
  }

  .input-area {
    width: 200px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .el-input {
      width: 100%;
    }
  }
  .message-list-container {
    position: absolute;
    bottom: 60px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    z-index: 980;
  }

  .message-list {
    width: max-content;
    overflow-y: auto;
    &::-webkit-scrollbar {
      width: 0;
    }
    .scroll-box {
      max-width: 242px;
      width: max-content;
      // max-height: 400px;
      // overflow-y: auto;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: flex-end;
      transition: max-width 0.2s ease;

      &.is-collapsed {
        max-width: 0;
        overflow: hidden;
        transition: max-width 0.2s ease;
        & > div {
          width: 0;
          padding: 0;
          margin-left: 0;
          margin-right: 0;
          border: none;
        }
      }

      &::-webkit-scrollbar {
        width: 0;
      }
    }

    .message-item {
      // min-width: max-content;
      max-width: 242px;
      background: rgba(24, 24, 27, 0.6);
      border-radius: 8px 8px 8px 8px;
      border: 1px solid rgba(24, 24, 27, 0.1);
      color: #fff;
      margin-top: 6px;
      padding: 4px;
      line-break: anywhere;
    }
  }

  .expand-collapse-button {
    margin-top: 6px;
    padding: 2px 4px 2px 7px;
    background: rgba(24, 24, 27, 0.6);
    border-radius: 8px;
    color: #fff;
    cursor: pointer;
    display: flex;
    align-items: center;
    font-size: 12px;
    line-height: 20px;
    transition: background 0.3s ease-in-out;
    z-index: 1;

    &.blinking {
      animation: blink-animation 1s infinite;
    }

    .icon {
      margin-right: 4px;
      font-weight: 500;
      font-size: 14px;
      // transition: transform 0.3s ease-in-out;
    }

    .text {
      opacity: 0;
      max-width: 0;
      overflow: hidden;
      transition: opacity 0.3s ease-in-out, max-width 0.3s ease-in-out;
      white-space: nowrap;
    }

    &:hover {
      .text {
        opacity: 1;
        max-width: 100px;
      }
    }
  }
}

.expand-collapse-button {
  .icon {
    &.is-collapsed {
      transform: rotate(180deg);
    }
  }
}

@keyframes blink-animation {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
}
</style>
